const hasCookieStore = () => window.cookieStore !== undefined

const getCookiesFromCookieStore = async () => {
    return (await window.cookieStore.getAll())
        .reduce(
            (cookies, cookie) => ({
                ...cookies,
                [cookie.name]: cookie.value
            }),
            {}
        )
}

const getCookiesFromDocumentString = () => {
    const regex = /(?:^|; )([^=]*)(?:=)([^;]*)(?:$|; )/g
    return  [...document.cookie.matchAll(regex)].reduce((cookies, matchedCookie) => ({
        ...cookies,
        [matchedCookie[1]]: matchedCookie[2]
    }), {})
}

/**
 * Gets all cookies from the current site
 * 
 * @returns {Promise<Object>}
 */
const getCookies = async () => {
    return hasCookieStore()
        ? await getCookiesFromCookieStore()
        : getCookiesFromDocumentString()
}

/**
 * Gets a single cookie from the current site
 * 
 * @param {String} cookie 
 * @returns {Promise<Object>}
 */
const getCookie = async (cookie) => {
    return hasCookieStore()
        ? (await window.cookieStore.get(cookie))?.value
        : getCookies()?.[cookie] 
}

/**
 * Checks if the site has a given cookie
 * 
 * @param {String} cookie 
 * @returns {Promise<Object>}
 */
const hasCookie = async (cookie) => {
    return hasCookieStore()
        ? (await window.cookieStore.get(cookie)) !== null
        : (await getCookies())?.[cookie] !== undefined
}

export {
    getCookies,
    getCookie,
    hasCookie
}